import { render } from "./AppCaret.vue?vue&type=template&id=4cbc7744&scoped=true&bindings={\"open\":\"props\"}"
import script from "./AppCaret.vue?vue&type=script&lang=js"
export * from "./AppCaret.vue?vue&type=script&lang=js"

import "./AppCaret.vue?vue&type=style&index=0&id=4cbc7744&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cbc7744"

export default script